import { Skeleton } from "antd"
import TodaysOrderCardSkeleton from "./TodaysOrderCardSkeleton"
import React from "react"

const TodaysOrderColumnSkeleton = () => {
  return (
    <>
      <div className="shadow border-b border-gray-200 w-full lg:w-1/5 h-5/6 p-6 rounded-2xl mx-2 mt-2">
        <div className="flex flex-col">
          <Skeleton.Input
            active
            size="small"
            style={{
              borderRadius: "8px",
              height: "1.2em",
              marginBottom: "1em",
            }}
          />
          <TodaysOrderCardSkeleton />
          <TodaysOrderCardSkeleton />
        </div>
      </div>
    </>
  )
}

export default TodaysOrderColumnSkeleton
